<template>
  <el-dialog
    title="选择轮毂高度"
    :visible="visible"
    width="20%"
    :before-close="handleCancel"
  >
    <span>
      <el-select v-model="hubHeight" placeholder="请选择" style="width:100%">
        <el-option
            v-for="item in hubHeights"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button :disabled="!hubHeight" type="primary" @click="handleSubmit"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { getTurbineList } from '../service';
export default {
  props: {
    visible: {
      type: Boolean
    },
    plan:{
      type: Object
    }
  },
  data() {
    return {
      hubHeights: [],
      hubHeight: null
    };
  },
  watch:{
    visible(v){
      if(v){
        this.getTurbineList();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {

    });
  },
  methods: {
    handleCancel() {
      this.hubHeight = null;
      this.$emit('close');
    },
    getTurbineList(){
      getTurbineList(this.plan.planId).then(res=>{
        const { data } = res;
        const { energyParam } = data;
        this.hubHeights = energyParam.hubHeights.split('/')
      });
    },
    async handleSubmit() {
      this.$emit('save', {params: 'planId='+ this.plan.planId +'&hubHeight='+this.hubHeight, data: this.plan});
      this.handleCancel();
    }
  }
};
</script>
